class CookieBanner {
  constructor(cookieConsent) {
    this.cookieConsent = cookieConsent;
    this.init();
  }

  init() {
    // Cache DOM elements
    this.container = document.querySelector(".mad-cc-banner__container");
    if (!this.container) return;

    this.acceptAllButton = this.container.querySelector(
      ".mad-cc-banner__button--accept-all"
    );
    this.denyAllButton = this.container.querySelector(
      ".mad-cc-banner__button--deny-all"
    );
    this.customizeButton = this.container.querySelector(
      ".mad-cc-banner__button--customize"
    );

    this.bindEvents();
  }

  bindEvents() {
    if (this.acceptAllButton) {
      this.acceptAllButton.addEventListener("click", () => this.onAcceptAll());
    }
    if (this.denyAllButton) {
      this.denyAllButton.addEventListener("click", () => this.onDenyAll());
    }
    if (this.customizeButton) {
      this.customizeButton.addEventListener("click", () => this.onCustomize());
    }
  }

  onAcceptAll() {
    // Delegate consent granting to CookieConsent
    this.cookieConsent.acceptAll();
  }

  onDenyAll() {
    // Delegate consent denial to CookieConsent
    this.cookieConsent.denyAll();
  }

  onCustomize() {
    // Show the modal through CookieModal
    this.cookieConsent.modal.show();
  }

  show() {
    if (!this.container) return;
    // The default banner container is `display: none` in CSS and relies on JS
    // to reveal it. Clearing the inline style first lets modes that set their
    // own display (e.g. floating = flex) win; if it's still hidden, force it
    // visible as a block (mirrors jQuery's .show() behaviour).
    this.container.style.display = "";
    if (getComputedStyle(this.container).display === "none") {
      this.container.style.display = "block";
    }
  }

  hide() {
    if (this.container) this.container.style.display = "none";
  }
}

module.exports = CookieBanner;
